import { render, staticRenderFns } from "./youjia.vue?vue&type=template&id=74977d4a&scoped=true"
import script from "./youjia.vue?vue&type=script&lang=js"
export * from "./youjia.vue?vue&type=script&lang=js"
import style0 from "./youjia.vue?vue&type=style&index=0&id=74977d4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74977d4a",
  null
  
)

export default component.exports